import { Box, Heading, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface SectionCardProps {
  heading?: string;
  children: ReactNode;
  spacing?: number;
  testId?: string;
}

export const SectionCard = ({
  heading,
  children,
  spacing = 5,
  testId,
}: SectionCardProps) => (
  <Box
    bg="white"
    borderRadius="xl"
    p={6}
    border="1px solid"
    borderColor="silver.500"
    boxShadow="0 1px 4px rgba(45, 66, 106, 0.04)"
    data-testid={testId}
  >
    <VStack align="stretch" spacing={spacing}>
      {heading && (
        <Heading size="sm" color="navyBlue.700">
          {heading}
        </Heading>
      )}
      {children}
    </VStack>
  </Box>
);
